module.exports = __webpack_public_path__ + "img/safari.ecf9a799.png";